// types
import { createSlice } from "@reduxjs/toolkit";

// initial state
const initialState = {
  auth: { token: null, customer: null, isAuthenticated: false, newBasket: null },
};

// ==============================|| SLICE - CUSTOMER ||============================== //

const customerAuth = createSlice({
  name: "customerAuth",
  initialState,
  reducers: {
    setAuth(state, action) {
      state.auth = action.payload;
    },
    logOut(state, action) {
      state.auth = initialState.auth;
    },
  },
});

export default customerAuth.reducer;

export const { setAuth, logOut } = customerAuth.actions;
// {
//   auth.isAuthenticated ? (
//     <Link to="/profile" className="panel-link">
//       <ListItemButton className={selectedMenu("/profile")}>
//         {openMenu ? <ListItemText primary=" ورود" /> : ""}
//         <ListItemIcon style={styleList}>
//           <LoginIcon className="ms-auto" />
//         </ListItemIcon>
//       </ListItemButton>
//     </Link>
//   ) : (
//     <>
//       <LoginIcon />
//       <p className="footer-link">ورود</p>
//     </>
//   );
// }
